import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/AuthService/auth.service';

@Injectable({ providedIn: 'root' })
export class AppGuard {
  constructor(
    private readonly authService: AuthService,
    private router: Router
  ) {}

  canActivate() {
    if (this.authService.isAuthenticatedAndTokenValid()) {
      return true;
    }

    this.authService.logout();
    return false;
  }
}
